import { render, staticRenderFns } from "./AppCol.vue?vue&type=template&id=43b38c1a&scoped=true&"
import script from "./AppCol.vue?vue&type=script&lang=js&"
export * from "./AppCol.vue?vue&type=script&lang=js&"
import style0 from "./AppCol.vue?vue&type=style&index=0&id=43b38c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b38c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
